export const DOMAIN = 'auth.user.notifications';
